import { Injectable } from '@angular/core';

import { format, toZonedTime } from 'date-fns-tz';

import { DealerSettingName } from '../interfaces/IDealerSettings';
import { PermissionsService } from './permissions.service';

@Injectable()
export class DatesService {
  constructor(private permissionsService: PermissionsService) {}

  setDateByDealerSetting(date: Date, formatDate: string): string {
    const dealerTimezone = this.permissionsService.getDealerSetting(DealerSettingName.dealerTimezone);
    if (!dealerTimezone) {
      return format(date, formatDate);
    } else {
      const zonedDate = toZonedTime(date, dealerTimezone.displayName);
      const formattedDate = format(zonedDate, formatDate);
      return formattedDate;
    }
  }
}
